import { useTranslation } from 'react-i18next'

export const MaintenanceScreen = () => {
  const { t } = useTranslation()

  return (
    <div className="flex h-screen w-full items-center justify-center bg-gradient-to-b from-gray-50 to-gray-100">
      <div className="max-w-2xl px-8 text-center">
        <div className="mb-8">
          <p className="mb-6 text-gray-700 text-lg">
            {t('maintenance.thanks')}
          </p>
          <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-amber-100">
            <svg
              className="h-12 w-12 text-amber-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <title>Maintenance Icon</title>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h1 className="mb-4 font-bold text-4xl text-gray-900">
            {t('maintenance.title')}
          </h1>
          <p className="mb-6 text-gray-700 text-lg">
            {t('maintenance.description')}
          </p>
          <div className="mb-6 rounded-lg bg-amber-50 p-4">
            <p className="font-semibold text-amber-800">
              {t('maintenance.period-label')}
            </p>
            <p className="text-amber-700">{t('maintenance.period')}</p>
          </div>
        </div>
        <p className="text-gray-600">{t('maintenance.message')}</p>
      </div>
    </div>
  )
}
